"use strict";

exports.__esModule = true;
exports.TimelineBarChartField = TimelineBarChartField;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Core = require("../../Core");
var _ColorPicker = require("../../Form/ColorPicker");
var _SelectorOption = require("../../Timeline/AdvancedTimeline/SelectorOption");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var StyledFormGroup = (0, _styledComponents["default"])(_core.FormGroup).withConfig({
  displayName: "TimelineBarChartField__StyledFormGroup",
  componentId: "sc-1eapkmh-0"
})(["margin:0 5px;"]);
function TimelineBarChartField(props) {
  var elementEditor = props.elementEditor,
    path = props.path,
    element = props.element;
  var _element$props = element.props,
    showBarChart = _element$props.showBarChart,
    barChartBackgroundColor = _element$props.barChartBackgroundColor,
    barChartScaleSource = _element$props.barChartScaleSource,
    barChartMinValue = _element$props.barChartMinValue,
    barChartMaxValue = _element$props.barChartMaxValue,
    type = _element$props.type;
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var isInSeconds = type === "duration";
  var setBarChartToggle = function setBarChartToggle(val) {
    if (val === false) {
      elementEditor.setProps(path, Object.assign({}, element.props, {
        showBarChart: val,
        barChartBackgroundColor: "#68ccca",
        barChartScaleSource: "auto"
      }));
    } else {
      elementEditor.setProps(path, Object.assign({}, element.props, {
        showBarChart: val,
        barChartBackgroundColor: barChartBackgroundColor || "#68ccca"
      }));
    }
  };
  var setBackgroundColor = function setBackgroundColor(color) {
    elementEditor.setProp(path, "barChartBackgroundColor", color);
  };
  var setBarChartScaleSource = function setBarChartScaleSource(scaleSource) {
    elementEditor.setProps(path, Object.assign({}, element.props, {
      barChartScaleSource: scaleSource,
      barChartMinValue: 0,
      barChartMaxValue: 100
    }));
  };
  var setBarChartMinValue = function setBarChartMinValue(min) {
    elementEditor.setProp(path, "barChartMinValue", min);
  };
  var setBarChartMaxValue = function setBarChartMaxValue(max) {
    elementEditor.setProp(path, "barChartMaxValue", max);
  };
  var scaleSources = [{
    id: "auto",
    label: translate("AdvancedTimeline.scaleSourcesSelector.autoScale", "Auto")
  }, {
    id: "custom",
    label: translate("AdvancedTimeline.scaleSourcesSelector.customScale", "Custom")
  }];
  var selectedScaleSource = barChartScaleSource && scaleSources.find(function (source) {
    return source.id === barChartScaleSource;
  });
  if (!selectedScaleSource) {
    setBarChartScaleSource(scaleSources[0].id);
    selectedScaleSource = scaleSources[0];
  }
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "BarChartField.showBarChart"
  }, /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    checked: showBarChart || false,
    label: translate("BarChartField.barChart.fieldValue", "Show Bar Chart"),
    onChange: function onChange() {
      return setBarChartToggle(!showBarChart);
    },
    style: {
      width: "fit-content"
    }
  })), showBarChart === true && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("BarChartField.BarChartColorSelector", "Select Bar Chart Color")
  }, /*#__PURE__*/_react["default"].createElement(_ColorPicker.ColorPicker, {
    "data-testid": "BarChartField.ColorPicker",
    value: barChartBackgroundColor || "#68ccca",
    onChange: function onChange(color) {
      return color && setBackgroundColor(color);
    }
  })), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("BarChartField.BarChartScaleSourcesSelector", "Scale Source")
  }, /*#__PURE__*/_react["default"].createElement(_Core.Selector, {
    items: scaleSources,
    getKey: function getKey(scaleSource) {
      return scaleSource.id;
    },
    selected: [selectedScaleSource],
    onSelect: function onSelect(selectedScaleSource) {
      return setBarChartScaleSource(selectedScaleSource[0].id);
    },
    renderItemText: function renderItemText(scaleSource) {
      return /*#__PURE__*/_react["default"].createElement(_SelectorOption.SelectorOption, {
        value: scaleSource.label,
        parentComponent: "TimelineBarChartField"
      });
    },
    placeholder: translate("BarChartField.BarChartScaleSourcesSelector.placeholder", "Scale Selector")
  }))), barChartScaleSource === "custom" && /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "BarChartField.CustomScaleSource",
    style: {
      display: "flex",
      flexDirection: "row"
    }
  }, /*#__PURE__*/_react["default"].createElement(StyledFormGroup, {
    label: translate("BarChartField.BarChartMinScale", "Min")
  }, /*#__PURE__*/_react["default"].createElement(_core.InputGroup, {
    type: "number",
    id: "minScale",
    name: "Min",
    value: barChartMinValue,
    onChange: function onChange(event) {
      return setBarChartMinValue(event.target.value);
    }
  }), isInSeconds ? /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      marginTop: "4px"
    }
  }, translate("BarChartField.BarChartCustomScaleSource.helperText", "Enter scale in seconds")) : null), /*#__PURE__*/_react["default"].createElement(StyledFormGroup, {
    label: translate("BarChartField.BarChartMaxScale", "Max")
  }, /*#__PURE__*/_react["default"].createElement(_core.InputGroup, {
    type: "number",
    id: "maxScale",
    name: "Max",
    value: barChartMaxValue,
    onChange: function onChange(event) {
      return setBarChartMaxValue(event.target.value);
    }
  }))));
}